import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import styles from "./index.module.less";
import classNames from "classnames";
import { isMobile } from "@/utils";
import Footer from "./Footer";
import ContactModal from "../ContactModal";
import { observer } from "mobx-react";
import { useStore } from "@/stores";
import Kefu from "../Kefu";
import { useEffect, useLayoutEffect } from "react";
import MobileHomeLayout from "./mobile";
import useApp from "antd/es/app/useApp";

const HomeLayout = ({ onlyBody }: { onlyBody?: boolean }) => {
  const appStore = useStore("app");
  const location = useLocation();
  const { message } = useApp();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  useEffect(() => {
    window.messageInstance = message;
  }, [message]);
  return (
    <div
      className={classNames(styles.homeLayout, {
        isMobile: isMobile(),
      })}
    >
      {onlyBody ? (
        <div className={styles.body}>
          <Outlet />
        </div>
      ) : (
        <>
          <Header />
          <div className={styles.body}>
            <Outlet />
          </div>
          <Footer />
          <div className={styles.kefu}>
            <Kefu />
          </div>
        </>
      )}
      <ContactModal
        visible={appStore.showContactModal}
        onClose={appStore.closeContactModal}
      />
    </div>
  );
};
export default isMobile() ? MobileHomeLayout : observer(HomeLayout);
